export default {
  en: {
    pageTitle: 'Pet Owner Information: Confirm & Edit'
  },
  ja: {
    pageTitle: '飼主様情報の確認・変更'
  }
}
